import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MimicActionsService {
    private pendingResponseElement = new Set();

    private actionSubject: Subject<{ elementId: string; channelTag: string; action: number }> = new Subject();
    private valueSubject: Subject<{ elementId: string; channelTag: string; value: number }> = new Subject();

    constructor() {}

    sendActionToFcu$ = this.actionSubject.asObservable();
    sendValueToFcu$ = this.valueSubject.asObservable();

    sendValue(elementId, channelTag, value) {
        if (this.pendingResponseElement.has(elementId)) {
            return;
        }
        this.pendingResponseElement.add(elementId);
        try {
            //TODO: Send value to FCU
            this.valueSubject.next({ elementId, channelTag, value });
        } catch (err) {
            console.error(err);
        }
    }

    sendButtonAction(elementId, channelTag, action) {
        if (this.pendingResponseElement.has(elementId)) {
            return;
        }
        this.pendingResponseElement.add(elementId);
        try {
            //TODO: Send value to FCU
            this.actionSubject.next({ elementId, channelTag, action });
        } catch (err) {
            console.error(err);
        }
    }

    hasPendingResponse(elementId): boolean {
        return this.pendingResponseElement.has(elementId);
    }

    actionSubjectResponse(elementId) {
        this.pendingResponseElement.delete(elementId);
    }

    valueSubjectResponse(elementId) {
        this.pendingResponseElement.delete(elementId);
    }
}
